<template>
	<div style="width: 100%;">
		<PageHeader @back="goback" :content="'样本配置'" />
		<div class="interviewerBox">
			<div class="searchQuert">
				<div class="leftSearch">
					<div>
						<span style="margin-right: 10px;">按时间</span>
						<el-date-picker
							size="medium"
							value-format="yyyy-MM-dd HH:mm:ss"
							v-model="timeValue"
							type="datetimerange"
							:picker-options="pickerOptions"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							align="right"
							@change="datePicker"
						></el-date-picker>
					</div>
					<div style="margin-left: 20px;">
						<span style="margin-right: 10px;">按状态</span>
						<el-select size="medium" v-model="samplesState" placeholder="请选择" @change="selectState">
							<el-option label="请选择" value=""></el-option>
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<div class="rightSearch">
					<el-input size="medium" placeholder="请输入内容" v-model="fieldValue" class="input-with-select">
						<el-select size="medium" class="withSelect" v-model="fieldName" slot="prepend" placeholder="请选择">
							<el-option v-for="item in selectList" :key="item.enfieldName" :label="item.chfieldName" :value="item.enfieldName"></el-option>
						</el-select>
						<el-button slot="append" icon="el-icon-search" @click="searchBtn"></el-button>
					</el-input>
				</div>
			</div>
			<div class="queryBtn">
				<div>
					<el-button size="medium" type="primary" v-if="source == 'df'" @click="samplingSurveyVisible = true">抽样导入</el-button>
					<el-button size="medium" type="primary" @click="dialogVisible = true">样本导入</el-button>
					<el-button size="medium" type="primary" @click="opendistinctSampleVisible">样本去重</el-button>
					<el-button size="medium" type="primary" @click="dataInitial">初始化样本</el-button>
					<el-button type="text" @click="setAs">设置展示列</el-button>
				</div>
				<div>
					<el-button size="medium" type="danger" @click="delForSample">删除样本</el-button>
					<el-button size="medium" type="danger" @click="delInitSample">删除初始化样本</el-button>
					<el-button size="medium" type="danger" @click="delAllSample">清空样本</el-button>
				</div>
			</div>

			<div v-if="samplingreviewState.state != 2" style="margin-bottom: 20px">
				<span v-if="samplingreviewState.state == 1" style="color: #0080ff">
					{{ samplingreviewState.errormsg }}
					<i
						class="el-icon-loading
			"
					></i>
					<!-- <span>
						<el-popconfirm title="确定要删除错误信息吗?" ok-text="确定" cancel-text="取消" @confirm="samplingdelErrmsg"
							@cancel="cancel">
							<el-button slot="reference">
								<i class="el-icon-close" style="cursor: pointer"></i>
							</el-button>
						</el-popconfirm>
					</span> -->
				</span>
			</div>

			<div class="topTable">
				<el-table @selection-change="handleSelectionChange" border :data="tableData" style="width: 100%" max-height="570">
					<el-table-column type="selection" width="40" v-if="activeHide"></el-table-column>
					<el-table-column type="selection" width="40" v-else></el-table-column>
					<el-table-column
						v-for="item in columnList"
						:key="item.enfieldName"
						align="center"
						:prop="item.enfieldName"
						:label="item.chfieldName"
						:fixed="item.fixed"
					></el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="150" v-if="activeHide">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="editRow(scope)">编辑</el-link>
							<el-popconfirm title="这确定删除吗？" @confirm="deleteRow(scope)">
								<el-link slot="reference" type="primary" :underline="false" style="margin-left: 10px;">删除</el-link>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pagination.currentPage"
						:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>
		</div>

		<!-- 导入详情 -->
		<el-dialog :title="uploadText" :visible.sync="dialogVisible" width="72%" :close-on-click-modal="false" :before-close="handleClose">
			<el-steps :active="active" align-center>
				<el-step title="数据源"></el-step>
				<el-step title="字段映射"></el-step>
				<el-step title="导入参数"></el-step>
			</el-steps>
			<dataOrigin v-if="active == 1" @uploadOk="uploadOk" @uploadfileOk="uploadfileOk" @radiokeyType="radiokeyType" :file="file"></dataOrigin>
			<datafields v-if="active == 2" ref="datafields" :fileData="fileData" :keyType="keyType" :filePath="filePath" @fileDataList="fileDataList"></datafields>
			<uploadData v-if="active == 3" ref="uploadData" :source="source" :keyType="keyType" :filePath="filePath" :fileData="fileData" @upLoadOk2="dataRefreh"></uploadData>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" v-if="active > 1" plain @click="last">上一步</el-button>
				<el-button size="medium" @click="next" v-if="active < 3">下一步</el-button>
				<el-button size="medium" :disabled="uploadType" :loading="uploadType" @click="importData" v-else>导入</el-button>
			</span>
		</el-dialog>
		<!-- 设置左中右 -->
		<setSampleTable ref="setSampleTable" @setOk="setOk"></setSampleTable>
		<!-- 样本去重 -->
		<el-dialog title="样本去重" :visible.sync="distinctSampleVisible" width="800px" :close-on-click-modal="false">
			<span>
				<el-tabs v-model="distinctWay" @tab-click="handleClick">
					<el-tab-pane label="本项目去重" name="1">
						<el-card class="currentProject" style="overflow-y: scroll;" shadow="never" v-if="distinctWay == '1'">
							<el-checkbox-group v-model="fielDistinctWay" size="medium">
								<el-checkbox
									style="margin-bottom: 10px;"
									v-for="item in newDeduplication"
									:key="item.enfieldName"
									:value="item.enfieldName"
									:label="item.enfieldName"
									border
								>
									<span>{{ item.chfieldName }}</span>
								</el-checkbox>
							</el-checkbox-group>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="根据其他项目去重" name="2">
						<el-card class="currentProject" shadow="never" v-if="distinctWay == '2'">
							<span>
								请选择对比项目
								 <!-- loading-text="加载中" -->
								<el-select :loading="projectsLoading" size="medium" v-model="OtherProjects" placeholder="请选择" @change="projectsChange">
									<el-option v-for="item in OtherProjectsOptions" :key="item.id" :label="$functions.filterHtmlTag(item.wjTitle)" :value="item.id"></el-option>
								</el-select>

								<!-- 选择对比项目后 进行表格显示 -->
								<el-table
									v-if="otherProjectsTableShow"
									:data="fieldContrast"
									border
									style="width: 100%; margin-top: 20px;"
									@selection-change="otherProjectsSelectionChange"
									height="308"
								>
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="chfieldName" label="字段名" align="center"></el-table-column>
									<el-table-column label="对比项目字段" align="center">
										<template slot-scope="scope">
											<el-select size="medium" placeholder="请选择" v-model="scope.row.field1" @change="value => contrastChange(value, scope.row)">
												<el-option
													v-for="(item, index) in otherProjectsDataList"
													:key="index"
													:label="item.chfieldName"
													:value="item.enfieldName"
												></el-option>
											</el-select>
										</template>
									</el-table-column>
								</el-table>
							</span>
						</el-card>
					</el-tab-pane>
				</el-tabs>
			</span>
			<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="datadistinctSample()">去重</el-button></span>
		</el-dialog>
		<!-- 查看详情 修改样本 -->
		<editSample ref="editSample" @eidtOK="eidtOK" :fieldContrast="fieldContrast"></editSample>
		<!-- 全部删除输入密码二次确定 -->
		<el-dialog title="请输入登录密码" :visible.sync="passWordVisible" width="30%" :close-on-click-modal="false">
			<span><el-input size="medium" placeholder="请输入密码" v-model="passWordInput" show-password></el-input></span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="passWordVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="delAllSampleNext()">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 抽样导入 -->
		<el-dialog title="抽样导入" :visible.sync="samplingSurveyVisible" width="1200px" :close-on-click-modal="false" :footer="false">
			<el-tabs v-model="samplingSurveyVal" @tab-click="samplingSurveyClick">
				<el-tab-pane label="抽样导入" name="1"><samplingTheImport v-if="samplingSurveyVal == 1" @importDataOk="importDataOk"></samplingTheImport></el-tab-pane>
				<el-tab-pane label="号段管理" name="2"><themRoughlyManagement v-if="samplingSurveyVal == 2"></themRoughlyManagement></el-tab-pane>
				<el-tab-pane label="抽号任务" name="3"><LotteryTask v-if="samplingSurveyVal == 3"></LotteryTask></el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 导入提示信息 -->
		<el-dialog title="导入信息" :visible.sync="ImportinformationVisible" width="500px" :close-on-click-modal="false">
			<div>
				<span>总数量 ： <span  style="color: #409eff">{{ samplingreviewState.errormsg.allTimes }}</span></span>
				<span style="display:inline-block;margin-left: 10px;">成功数量 ： <span style="color: #67C23A;">{{ samplingreviewState.errormsg.successTimes }}</span></span>
				<span style="display:inline-block;margin-left: 10px;">失败数量 ： <span style="color: #F56C6C;">{{ samplingreviewState.errormsg.failTimes }}</span></span>
				<div style="margin-top: 10px;" v-if="samplingreviewState.errormsg.failTimes > 0 && samplingreviewState.errormsg.failMessgae.length > 0">
					<el-button size="medium" @click="errormsgVisible = true">查看失败信息</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="ImportinformationVisible = false">关闭</el-button></span>
		</el-dialog>

		<!-- 失败信息 -->
		<el-dialog title="失败信息" :visible.sync="errormsgVisible" width="500px" :close-on-click-modal="false">
			<div style="max-height: 500px; overflow: auto;">
				<p v-for="(item, index) in samplingreviewState.errormsg.failMessgae" :key="index">{{ item }}</p>
			</div>
			<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="errormsgVisible = false">关闭</el-button></span>
		</el-dialog>
	</div>
</template>

<script>
import dataOrigin from './step/dataOrigin.vue';
import datafields from './step/datafields.vue';
import uploadData from './step/uploadData.vue';
import setSampleTable from './setSampleTable/index.vue';
import editSample from './editSample';
import samplingTheImport from './sampling/samplingTheImport.vue';
import themRoughlyManagement from './sampling/themRoughlyManagement.vue';
import LotteryTask from './sampling/LotteryTask.vue';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		dataOrigin,
		datafields,
		uploadData,
		setSampleTable,
		editSample,
		samplingTheImport, //抽样导入、
		themRoughlyManagement, //号段管理
		LotteryTask, //抽号任务
		PageHeader
	},
	data() {
		return {
			errormsgVisible: false,
			newDeduplication: [],
			ImportinformationVisible: false,
			samplingIntervalId: null,
			samplingreviewState: {
				errormsg: '',
				state: 2
			},
			uploadText: '导入电话样本',
			selectList: [],
			intervalId: null,
			samplingSurveyVal: '1',
			samplingSurveyVisible: false,
			/* 抽样导入 */
			file: {},
			source: '',
			uploadType: false,
			keyType: ';', //上传文件分隔符
			// 登录密码
			passWordInput: '', //二次确认密码
			passWordVisible: false,
			otherQId: '', //另一个项目id
			contrastArray: {}, //重构结构对象
			otherProjectsTableShow: false, //表格显示隐藏
			otherProjectstableData: [], //数据
			otherProjectsDataList: [], //其他项目数据
			projectsLoading: false,
			OtherProjectsOptions: [], //其他项目
			OtherProjects: '', //其他项目
			activeName: 'second',
			fielDistinctWay: [], //选择去重字段
			distinctWay: '1', //去重方式
			distinctSampleVisible: false,
			multipleSelection: [], //选择的样本数据
			fieldValue: '', //搜索输入
			fieldName: '', //搜索选择
			timeValue: '', //绑定时间
			samplesState: '',
			beginTime: '', //开始时间
			endTime: '', //结束时间
			activeHide: false,
			columnList: [],
			fieldContrast: [], //表头
			tableData: [], //全部样本数据(值)
			allSample: [], //全部样本数据(值)
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			select: '',
			id: '',
			importType: '',
			fileData: '',
			filePath: '',
			active: 1,
			dialogVisible: false,
			input3: '',
			options: [
				{
					value: '1',
					label: '初始状态'
				},
				{
					value: '2',
					label: '已被读取'
				},
				{
					value: '3',
					label: '中断状态'
				},
				{
					value: '6',
					label: '完成状态'
				},
				{
					value: '4',
					label: '甄别状态'
				},
				{
					value: '7',
					label: '配额已满'
				},
				{
					value: '8',
					label: '无效样本'
				},
				{
					value: '9',
					label: '预拨取号'
				}
			],

			pickerOptions: {
				shortcuts: [
					{
						text: '一年前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
							picker.$emit('pick', date);
						}
					},
					{
						text: '半年前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
							picker.$emit('pick', date);
						}
					},
					{
						text: '三个月前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', date);
						}
					},
					{
						text: '一个月前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					},
					{
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}
				]
			}
		};
	},
	computed: {
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		}
	},
	destroyed() {
		// 在页面销毁后，清除计时器
		this.clear();
		this.samplingClear();
	},
	created() {
		this.id = this.$route.query.id;
		this.source = this.$route.query.source;
		if (this.source == 'df') {
			this.uploadText = '导入电话样本';
		} else {
			this.uploadText = '导入样本';
		}
		this.queryAllFieldName(); //设置表头
		this.queryAllSample(); //获取数据
	},
	methods: {
		// 删除消息提示
		delErrmsg() {
			this.clear();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deleteSampleImportRedis}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.queryAllSample(); //获取数据
					} else {
						that.queryAllSample(); //获取数据
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 定时刷新数据函数
		dataRefreh() {
			// 计时器正在进行中，退出函数
			if (this.intervalId != null) {
				return;
			}
			this.loadingData()
			// 计时器为空，操作
			this.intervalId = setInterval(() => {
				this.loadingData(); // 加载数据函数
			}, 1000);
		},
		// 停止定时器
		clear() {
			clearInterval(this.intervalId); // 清除计时器
			this.intervalId = null; // 设置为null
		},
		cancel() {},
		loadingData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.querySampleImportState}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						if (res.resultBody.state == 2) {
							that.upLoadOk2()
							that.queryAllSample();
							that.clear();
							that.samplingreviewState.errormsg = JSON.parse(res.resultBody.errormsg)
							that.ImportinformationVisible = true;
						}
					} else {
						that.queryAllSample();
						that.clear();
					}
				}
			};
			this.$util.request(params);
		},
		opendistinctSampleVisible() {
			this.otherQId = '';
			this.OtherProjects = '';
			this.contrastArray = {};
			this.fielDistinctWay = [];
			this.distinctWay = '1';
			this.otherProjectsTableShow = false;
			this.distinctSampleVisible = true;
		},

		// 抽样导入-------------------------------------------------------------------
		samplingdelErrmsg() {
			this.samplingClear();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deleteImportPhoneTaskRedis}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.samplingreviewState.state = 2;
						that.queryAllSample(); //获取数据
					} else {
						that.queryAllSample(); //获取数据
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		samplingloadingData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryImportPhoneTaskState}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.samplingreviewState = res.resultBody;
						if (that.samplingreviewState.state == 2) {
							that.queryAllSample();
							that.samplingClear();
							that.samplingreviewState.errormsg = JSON.parse(that.samplingreviewState.errormsg);
							
							that.ImportinformationVisible = true;
						}
					} else {
						that.queryAllSample();
						that.samplingClear();
					}
				}
			};
			this.$util.request(params);
		},
		// 定时刷新数据函数
		samplingDataRefreh() {
			// 计时器正在进行中，退出函数
			if (this.samplingIntervalId != null) {
				return;
			}
			// 计时器为空，操作
			this.samplingIntervalId = setInterval(() => {
				this.samplingloadingData(); // 加载数据函数
			}, 5000);
		},
		// 停止定时器
		samplingClear() {
			clearInterval(this.samplingIntervalId); // 清除计时器
			this.samplingIntervalId = null; // 设置为null
		},
		importDataOk() {
			this.samplingSurveyVisible = false;
			this.samplingDataRefreh(); //获取数据
		},
		// 抽样导入-------------------------------------------------------------------end
		samplingSurveyClick(tab, event) {
			// console.log(this.samplingSurveyVal);
		},
		/* 抽样导入 */
		uploadfileOk(value) {
			console.log(value, 'uploadfileOk');
			this.file = value;
		},
		radiokeyType(value) {
			this.keyType = value;
		},
		// 设置样本状态
		setStatusText(value) {
			if (value == 1) {
				return '初始状态';
			} else if (value == 2) {
				return '已被读取';
			} else if (value == 3) {
				return '中断状态';
			} else if (value == 6) {
				return '完成状态';
			} else if (value == 4) {
				return '甄别状态';
			} else if (value == 7) {
				return '配额已满';
			} else if (value == 8) {
				return '无效样本';
			} else if (value == 9) {
				return '预拨取号';
			}
		},
		setOk() {
			this.queryAllFieldName(); //设置表头
			this.queryAllSample(); //获取数据
		},
		contrastChange(value, scope) {
			console.log(value, scope);
			scope.field2 = value;
		},
		otherProjectsSelectionChange(val) {
			var obj = {};
			val.map(function(e, item) {
				obj[e.field2] = e.enfieldName;
			});
			this.contrastArray = obj;
		},
		projectsChange(value) {
			console.log(value);
			this.otherQId = value; //另一个项目id
			this.otherProjectsData(value);
		},
		otherProjectsData(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: id
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.otherProjectsTableShow = true;
						that.otherProjectsDataList = res.resultBody.questionsFieldMappings;
						// item.field1 = item.enfieldName;
						that.fieldContrast.forEach(item => {
							that.otherProjectsDataList.forEach(item2 => {
								if (item.chfieldName == item2.chfieldName) {
									item.field1 = item2.chfieldName;
									item.field2 = item2.enfieldName;
								}
							});
						});
					} else {
						that.otherProjectsTableShow = false;
						that.otherProjectsDataList = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		mywjlistData() {
			let that = this;
			this.projectsLoading = true
			let params = {
				that: this,
				url: `${this.$config.service.mywjlist}?pageIndex=${1}&pageSize=${10000}`,
				method: 'post',
				data: {},
				cb(res) {
					// console.log({ res });
					if (res.code == 0) {
						that.OtherProjectsOptions = res.resultBody.datas;
						console.log('that.OtherProjectsOptions', that.OtherProjectsOptions);
						that.OtherProjectsOptions.forEach((item, index) => {
							console.log('item :>> ', item);
							if (item.id == that.id) {
								that.OtherProjectsOptions.splice(index, 1);
							}
						});
					} else {
						that.OtherProjectsOptions = [];
					}
				},
				finally() {
					that.projectsLoading = false
				}
			};
			this.$util.request(params);
		},
		// 样本去重
		handleClick(tab, event) {
			console.log(this.fieldContrast);
			this.mywjlistData();
		},
		// 编辑成功
		eidtOK() {
			this.queryAllSample(); //获取数据
		},
		// 编辑
		editRow(scope) {
			this.$refs.editSample.disabled = false;
			this.$refs.editSample.title = '编辑样本';
			this.$refs.editSample.form = JSON.parse(JSON.stringify(scope.row));
			this.$refs.editSample.loadData();
		},
		// 样本去重
		datadistinctSample() {
			console.log(this.fielDistinctWay);
			let fieldName = '';
			let fieldNameMap = '';
			if (this.distinctWay == 1) {
				fieldName = this.fielDistinctWay.toString(); // checkboxGroup1
				fieldNameMap = {};
			} else if (this.distinctWay == 2) {
				fieldName = '';
				fieldNameMap = this.contrastArray;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.distinctSample}`,
				method: 'POST',
				data: {
					distinctWay: this.distinctWay,
					fieldName: fieldName,
					fieldNameMap: fieldNameMap,
					qid: this.id,
					otherQId: this.otherQId,
					source: this.source
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.distinctSampleVisible = false;
						that.otherQId = '';
						that.contrastArray = {};
						that.fielDistinctWay = [];

						that.pagination.currentPage = 1;
						that.queryAllSample(); //获取数据
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		dataInitial() {
			if (this.multipleSelection.length == 0) {
				this.$message({
					message: '请选择要初始化的样本',
					type: 'warning'
				});
				return false;
			}

			this.$confirm('将所有选中样本进行初始化操作, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.initSample}`,
						method: 'POST',
						data: {
							id: this.multipleSelection.toString(),
							qid: this.id
						},
						cb(res) {
							console.log('查询全部全部字段对照', res);
							if (res.code == 0) {
								that.queryAllSample(); //获取数据
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除初始样本操作'
					});
				});
		},
		delForSample() {
			if (this.multipleSelection.length == 0) {
				this.$message({
					message: '请选择要删除的样本',
					type: 'warning'
				});
				return false;
			}

			this.$confirm('将删除所有选中样本, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.removeSampleBySampleId}`,
						method: 'POST',
						data: {
							id: this.multipleSelection.toString(),
							qid: this.id
						},
						cb(res) {
							console.log('查询全部全部字段对照', res);
							if (res.code == 0) {
								that.queryAllSample(); //获取数据
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除所有选中样本操作'
					});
				});
		},
		handleSelectionChange(val) {
			// this.multipleSelection = val;
			console.log(val);
			let multipleSelection = [];
			let tempSelection = val;
			tempSelection.forEach(item => {
				multipleSelection.push(item.id);
			});
			this.multipleSelection = multipleSelection;
		},
		// 删除初始样本
		delInitSample() {
			this.$confirm('将删除全部初始样本, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.removeInitSample}`,
						method: 'POST',
						data: {
							qid: this.id,
							source: this.source
						},
						cb(res) {
							console.log('查询全部全部字段对照', res);
							if (res.code == 0) {
								that.queryAllSample(); //获取数据
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除初始样本操作'
					});
				});
		},
		delAllSampleNext() {
			if (this.passWordInput == '') {
				this.$message.warning('请输入账户密码。');
				return false;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.removeAllSample}`,
				method: 'POST',
				data: {
					qid: this.id,
					password: this.passWordInput,
					source: this.source
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.queryAllSample(); //获取数据
						that.passWordVisible = false;
						that.passWordInput = '';
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 全部删除
		delAllSample() {
			this.$confirm('将删除全部样本, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.passWordVisible = true;
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消全部删除操作'
					});
				});
		},
		// 单个删除
		deleteRow(scope) {
			console.log(scope.row.id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.removeOneSample}`,
				method: 'POST',
				data: {
					id: scope.row.id,
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.queryAllSample(); //获取数据
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		selectState(value) {
			console.log('状态', value);
			this.samplesState = value;
			this.queryAllSample();
		},
		datePicker(value) {
			if (value != null) {
				console.log('时间选择124', value, value.length);
				let date = new Date();
				if (value.length == undefined) {
					this.beginTime = value;
					this.endTime = date;
				} else {
					this.beginTime = value[0];
					this.endTime = value[1];
				}
			}
			this.queryAllSample();
		},
		searchBtn() {
			this.queryAllSample();
		},
		queryAllFieldName() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.fieldContrast = res.resultBody.questionsFieldMappings;

						let Deduplication = [];
						let newfieldContrast = JSON.parse(JSON.stringify(that.fieldContrast));
						newfieldContrast.forEach(item => {
							if (item.isSysField == 2) {
								Deduplication.push(item);
							}
							if (item.enfieldName == 'piAreaCode') {
								Deduplication.push(item);
							}
							if (item.enfieldName == 'phone') {
								Deduplication.push(item);
							}
						});
						that.newDeduplication = Deduplication
						console.log(that.otherProjectsDataList);
						//查询问卷左中右显示字段
						that.queryFieldConfig();
					} else {
						that.fieldContrast = [];
						that.newDeduplication = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		SampleOk() {
			let list1 = [];
			let list2 = this.columnList;
			let list3 = [
				{
					chfieldName: '操作'
				}
			];
			let that = this;
			let data = {
				leftFieldName: JSON.stringify(list1),
				centreFieldName: JSON.stringify(list2),
				rightFieldName: JSON.stringify(list3),
				qid: that.id
			};
			let params = {
				that: this,
				url: `${this.$config.service.modifyFieldConfig}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						// that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryFieldConfig() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFieldConfig}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询左中右', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							let leftList = JSON.parse(res.resultBody.leftFieldName);
							let centreList = JSON.parse(res.resultBody.centreFieldName);
							let rightList = JSON.parse(res.resultBody.rightFieldName);
							leftList.forEach(item => {
								item.fixed = 'left';
							});
							rightList.forEach(item => {
								item.fixed = 'right';
							});
							// console.log(leftList, centreList, rightList);

							let tempAllList = [...leftList, ...centreList, ...rightList];
							that.activeHide = false;
							tempAllList.forEach((item, index) => {
								console.log('item :>> ', item);
								if (item.chfieldName == '操作') {
									tempAllList.splice(index, 1);
									that.activeHide = true;
								}
							});
							console.log('tempAllList', tempAllList);
							that.columnList = tempAllList;
							console.log('that.columnList :>> ', that.columnList);
							let selectList = JSON.parse(JSON.stringify(tempAllList));
							selectList.forEach((item, index) => {
								// console.log(item);
								if (item.enfieldName == 'answerState') {
									selectList.splice(index, 1);
								}
								if (item.enfieldName == 'answerName') {
									selectList.splice(index, 1);
								}
							});
							that.selectList = selectList;
						} else {
							that.columnList = [
								{
									chfieldName: '样本编号',
									enfieldName: 'autoId'
								},
								{
									chfieldName: '样本状态',
									enfieldName: 'answerState'
								},
								{
									chfieldName: '样本状态名称',
									enfieldName: 'answerName'
								},
								{
									chfieldName: '电话号码',
									enfieldName: 'phone'
								},
								{
									chfieldName: '电话区号',
									enfieldName: 'piAreaCode'
								},
								{
									chfieldName: '电话分机',
									enfieldName: 'piExt'
								}
							];
							that.selectList = [
								{
									chfieldName: '样本编号',
									enfieldName: 'autoId'
								},

								{
									chfieldName: '电话号码',
									enfieldName: 'phone'
								},
								{
									chfieldName: '电话区号',
									enfieldName: 'piAreaCode'
								},
								{
									chfieldName: '电话分机',
									enfieldName: 'piExt'
								}
							];
							that.SampleOk();
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		//函数封装
		resArr(arr1, arr2) {
			return arr1.filter(v => arr2.every(val => val.chfieldName != v.chfieldName));
		},

		// 查询本问卷全部样本
		queryAllSample() {
			let data = {
				beginTime: this.beginTime,
				endTime: this.endTime,
				samplesState: this.samplesState,
				fieldValue: this.fieldValue,
				fieldName: this.fieldName,
				currentPage: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				qid: this.id,
				source: this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllSample}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log('查询列表', res);
					if (res.code == 0) {
						that.tableData = res.resultBody.result;
						that.pagination.total = res.resultBody.totalCount;
						if (that.tableData.length == 0) {
							if (that.pagination.currentPage != 1) {
								that.pagination.currentPage = that.pagination.currentPage - 1;
								that.queryAllSample();
							}
						}
						that.multipleSelection = [];
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.multipleSelection = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 设置
		setAs() {
			this.$refs.setSampleTable.loadData();
		},
		upLoadOk2() {
			// 导入成功
			this.uploadType = false;
			this.dialogVisible = false;
			this.fileData = '';
			this.file = {};
			this.filePath = '';
			this.active = 1;

			this.$forceUpdate();
		},
		importData() {
			this.uploadType = true;
			this.$refs.uploadData.importData();
		},
		fileDataList(data, type) {
			console.log('1111111', data);
			this.fileData = data;
			let newfilePath = JSON.parse(data);
			if (newfilePath.length == 0) {
				this.$message('请添加映射');
				this.active--;
				return false;
			} else {
				let newPhone = [];
				newfilePath.forEach(item => {
					newPhone.push(Object.values(item)[0]);
				});
				let phoneShow = false;
				newPhone.forEach(item => {
					if (item == '电话号码') {
						phoneShow = true;
					}
				});
				if (this.source == 'df') {
					if (!phoneShow) {
						if (type == 2) {
							this.$message('请添加电话号码映射');
							if (this.active == 2) {
								this.active = 1;
							}
							return false;
						}
					}
				}
			}
		},
		uploadOk(filePath) {
			this.filePath = filePath;
		},
		last() {
			if (this.active-- < 1) this.active = 1;
		},
		next() {
			console.log('this.active ', this.active);
			if (this.active == 1) {
				if (this.filePath == '') {
					this.$message.warning('请先上传数据源文件');
					return false;
				}
			} else if (this.active == 2) {
				this.$refs.datafields.queryNewtableData();
			}
			if (this.active++ > 2) this.active = 1;
		},
		handleClose(done) {
			let _this = this;
			this.$confirm('确认关闭？')
				.then(_ => {
					_this.fileData = '';
					_this.file = {};
					_this.filePath = '';
					_this.active = 1;
					done();
				})
				.catch(_ => {});
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.currentPage = val;
			this.queryAllSample();
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style lang="scss" scoped>
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;

	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}

	margin-bottom: 20px;
	cursor: pointer;
}

.interviewerBox {
	padding: 0 20px 20px 20px;
	margin: 0px auto;

	.searchQuert {
		font-size: 14px;
		margin-bottom: 20px;
		display: flex;
		// justify-content: space-between;

		.leftSearch {
			display: flex;
		}

		.rightSearch {
			width: 390px;
			margin-left: 20px;
			.el-select .el-input {
				width: 130px;
			}

			/deep/.el-input-group__prepend {
				background-color: #fff;
			}
			.input-with-select .withSelect {
				width: 130px;
			}
		}
	}

	.queryBtn {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		align-items: center;
	}

	.topTable {

		.radioBtn {
			text-align: right;
			margin-top: 20px;
		}

		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
}

// 样本去重
.currentProject {
	height: 400px;
	/deep/.el-checkbox.is-bordered.el-checkbox--medium{
		line-height: 17px;
	}
	/deep/.el-checkbox.is-bordered+.el-checkbox.is-bordered{
		margin-left: 0;
	}
}
</style>
